import { styled } from "styled-components";

export const TextWithGradient = styled.h2<{
  $align?: string;
  $color?: string;
  $gradient: string;
}>`
  font-size: 32px;
  text-align: ${({ $align = "left" }): string => $align};
  background: -webkit-linear-gradient(${({ $gradient }): string => $gradient});
  -webkit-background-clip: text;
  -webkit-text-fill-color: ${({ $color = "transparent" }): string => $color};
  font-weight: 600;
  font-family: Roboto;
  display: inline;
`;
